/**
 * Banner visible solo cuando REACT_APP_ENV=staging.
 * Requerido por configuracionempresa.js y AuthShell (imports existentes en HEAD).
 * En producción retorna null — sin impacto visual en hosting nexopos-dc.
 */
import React from 'react';
import { isStagingEnv, isStagingMisconfigured, getFirebaseProjectId } from '../../config/appEnvironment';

const StagingBanner = ({ className = '' }) => {
  if (!isStagingEnv()) return null;

  const misconfigured = isStagingMisconfigured();

  return (
    <div
      className={[
        'border-b px-4 py-2 text-center text-xs font-semibold sm:text-sm',
        misconfigured
          ? 'border-red-400/40 bg-red-500/15 text-red-200'
          : 'border-amber-400/40 bg-amber-500/15 text-amber-100',
        className
      ].join(' ')}
      role="status"
    >
      {misconfigured ? (
        <>
          Staging mal configurado: apunta a producción (`nexopos-dc`). Copiá{' '}
          <code className="rounded bg-black/30 px-1">client/.env.staging.local.example</code> →{' '}
          <code className="rounded bg-black/30 px-1">.env.staging.local</code> y volvé a compilar.
        </>
      ) : (
        <>
          Entorno STAGING — proyecto <strong>{getFirebaseProjectId()}</strong>. Los datos no son los de
          producción.
        </>
      )}
    </div>
  );
};

export default StagingBanner;
